<template>
  <v-card class="rounded-lg elevation-3" height="100vh">
    <!-- Enhanced Header -->
    <v-card-title class="headline primary white--text py-3 d-flex justify-space-between">
      <span class="d-flex align-center">
        <v-icon left large color="white">mdi-view-grid</v-icon>
        Catálogo de Artículosss
        <v-chip v-if="totalItems > 0" small color="rgba(255,255,255,0.2)" text-color="white" class="ml-3">
          {{ totalItems.toLocaleString() }} artículos
        </v-chip>
      </span>
      <v-btn icon @click="$emit('close-item')" class="white--text">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="pa-3">
      <!-- Compact Filters Header -->
      <v-card outlined class="mb-3 filter-header">
        <v-card-text class="py-3">
          <v-row dense align="center">
            <!-- Main Search -->
            <v-col cols="12" sm="6" md="3" lg="3">
              <v-text-field v-model="search" label="Buscar artículo..." prepend-inner-icon="mdi-magnify" clearable
                outlined dense :disabled="only_mfnr_item" hide-details class="search-field" :loading="searchLoading"
                @input="updateSearch" @keydown.enter="onSearchSubmit" />
            </v-col>

            <!-- Category Filter -->
            <v-col cols="12" sm="6" md="2" lg="2">
              <v-select v-model="selectedCategory" :items="categoriesWithAll" item-text="name" item-value="id"
                label="Categoría" outlined dense :disabled="only_mfnr_item" hide-details :loading="loadingCategories"
                @change="onCategoryChange">
                <template v-slot:prepend-inner>
                  <v-icon small color="grey">mdi-shape</v-icon>
                </template>
              </v-select>
            </v-col>

            <!-- Warehouse Filter -->
            <!-- <v-col v-if="showWarehouse" cols="12" sm="6" md="2" lg="2">
              <v-select
                v-model="selectedWarehouse"
                :items="warehousesWithAll"
                item-text="name"
                item-value="id"
                label="Almacén"
                outlined
                dense
                hide-details
                :loading="loadingWarehouses"
                @change="onWarehouseChange"
              >
                <template v-slot:prepend-inner>
                  <v-icon small color="grey">mdi-warehouse</v-icon>
                </template>
              </v-select>
            </v-col> -->

            <!-- Quick Filters -->
            <!-- <v-col cols="12" sm="6" md="2" lg="2">
              <div class="d-flex flex-column">
                <v-checkbox
                  v-model="filters.showOnlyAvailable"
                  label="Solo disponibles"
                  color="success"
                  hide-details
                  dense
                  class="ma-0 pa-0"
                  @change="onAvailabilityFilterChange"
                />
                <v-checkbox
                  v-model="filters.showOnlyWithImages"
                  label="Solo con imagen"
                  color="info"
                  hide-details
                  dense
                  class="ma-0 pa-0 mt-1"
                  @change="onImageFilterChange"
                />
              </div>
            </v-col> -->

            <!-- Page Size and Actions -->
            <v-col cols="12" sm="12" md="3" lg="3" class="d-flex align-center justify-end">
              <v-select v-model="options.itemsPerPage" :items="itemsPerPageOptions" label="Por página" dense
                :disabled="only_mfnr_item" outlined hide-details style="width: 110px" class="mr-3"
                @change="onPageSizeChange" />

              <v-btn v-if="hasActiveFilters" small text :disabled="only_mfnr_item" color="primary"
                @click="clearAllFilters" class="mr-2">
                <v-icon small left>mdi-filter-off</v-icon>
                Limpiar
              </v-btn>

              <v-btn color="primary" outlined small :disabled="only_mfnr_item" @click="refreshData" :loading="loading">
                <v-icon small>mdi-refresh</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- Enhanced Data Table -->
      <v-data-table :headers="computedHeaders" :items="paginatedItems" :loading="loading" :options.sync="options"
        :server-items-length="totalItems" :footer-props="footerProps" height="calc(100vh - 220px)" fixed-header
        class="elevation-1 optimized-table" :mobile-breakpoint="960" disable-sort>
        <!-- Mobile-friendly combined item display -->
        <template v-if="$vuetify.breakpoint.mobile" v-slot:item.item_name="{ item }">
          <div class="mobile-item-container">
            <div class="d-flex align-center">
              <v-avatar size="36" class="mr-2">
                <v-img :src="getItemImage(item)" :alt="item.item_name" :lazy-src="defaultImage">
                  <template v-slot:placeholder>
                    <v-icon color="grey lighten-2" small>mdi-image</v-icon>
                  </template>
                </v-img>
              </v-avatar>
              <div class="flex-grow-1">
                <div class="text-subtitle-2 font-weight-medium text-truncate">
                  {{ item.item_name }}
                </div>
                <div class="text-caption text--secondary">
                  ID: {{ item.item_id }} • {{ item.unit_name }}
                </div>
                <div v-if="showWarehouse && item.warehouse_discount" class="text-caption">
                  <v-chip x-small :color="getWarehouseChipColor(item.warehouse_discount)">
                    {{ item.warehouse_discount.name }}
                  </v-chip>
                </div>
              </div>
            </div>
          </div>
        </template>

        <!-- Desktop Enhanced Image Column -->
        <template v-if="!$vuetify.breakpoint.mobile" v-slot:item.image="{ item }">
          <div class="image-container">
            <v-avatar size="36" class="image-avatar" @click="showImagePreview(item)">
              <v-img :src="getItemImage(item)" :alt="item.item_name" :lazy-src="defaultImage" class="cursor-pointer">
                <template v-slot:placeholder>
                  <v-icon color="grey lighten-2" small>mdi-image</v-icon>
                </template>
              </v-img>
            </v-avatar>
          </div>
        </template>

        <!-- Desktop Enhanced Description Column -->
        <template v-if="!$vuetify.breakpoint.mobile" v-slot:item.item_name="{ item }">
          <div class="item-description">
            <div class="text-subtitle-2 font-weight-medium text-truncate" style="max-width: 300px">
              {{ item.item_name }}
            </div>
            <div v-if="item.item_note" class="text-caption text--secondary text-truncate" style="max-width: 300px">
              {{ item.item_note }}
            </div>
            <div class="text-caption text-primary">
              ID: {{ item.item_id }}
            </div>
          </div>
        </template>

        <!-- Enhanced Warehouse Column -->
        <template v-if="showWarehouse" v-slot:item.warehouse="{ item }">
          <v-select v-model="item.warehouse_discount" :items="getWarehouseOptions(item)" item-text="name"
            item-value="id" label="Almacén" outlined dense hide-details return-object
            @change="updateItemWarehouse(item)"></v-select>

        </template>

        <!-- Enhanced Quantity Column -->
        <template v-slot:item.quantity="{ item }">
          <v-chip :color="getQuantityColor(item)" text-color="white" small label class="font-weight-bold">
            <v-icon left x-small>{{ getQuantityIcon(item) }}</v-icon>
            {{ formatQuantity(getItemQuantity(item)) }}
          </v-chip>
        </template>

        <!-- Enhanced Price Column -->
        <template v-slot:item.price="{ item }">
          <div class="price-container text-right">
            <div class="text-subtitle-1 font-weight-bold text-success">
              {{ formatCurrency(getPrice(item)) }}
            </div>
            <div v-if="type === 2 && item.cost_price && !$vuetify.breakpoint.mobile"
              class="text-caption text--secondary">
              Costo: {{ formatCurrency(item.cost_price) }}
            </div>
          </div>
        </template>

        <!-- Compact Actions Column -->
        <template v-slot:item.actions="{ item }">
          <v-btn :color="getActionButtonColor(item)" small :disabled="!canSelectItem(item)" :loading="item.selecting"
            @click="selectItem(item)" class="action-btn text-none" min-width="80">
            <v-icon small left>{{ getActionIcon(item) }}</v-icon>
            Agregar
          </v-btn>
        </template>

        <!-- Enhanced Empty State -->
        <template v-slot:no-data>
          <div class="empty-state text-center pa-8">
            <v-icon size="80" color="grey lighten-2">
              {{ getEmptyStateIcon() }}
            </v-icon>
            <div class="text-h5 mt-4 mb-2 text--secondary">
              {{ getEmptyStateTitle() }}
            </div>
            <div class="text-body-1 text--secondary mb-4">
              {{ getEmptyStateMessage() }}
            </div>
            <v-btn v-if="hasActiveFilters" color="primary" outlined @click="clearAllFilters">
              <v-icon left>mdi-filter-off</v-icon>
              Limpiar filtros
            </v-btn>
          </div>
        </template>

        <!-- Loading Progress -->
        <template v-slot:progress>
          <v-progress-linear indeterminate color="primary" height="3" />
        </template>
      </v-data-table>
    </v-card-text>

    <!-- Enhanced Snackbar -->
    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="snackbarTimeout" top right>
      <v-icon left color="white">{{ getNotificationIcon(snackbarColor) }}</v-icon>
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text color="white" v-bind="attrs" @click="snackbar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <!-- Image Preview Dialog -->
    <v-dialog v-model="imagePreview.show" max-width="600">
      <v-card>
        <v-card-title class="pb-2">
          {{ imagePreview.item?.item_name }}
          <v-spacer />
          <v-btn icon @click="imagePreview.show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-img :src="getItemImage(imagePreview.item)" :alt="imagePreview.item?.item_name" height="400" contain />
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Loading Overlay -->
    <v-overlay v-if="initialLoading" absolute>
      <div class="text-center">
        <v-progress-circular indeterminate size="64" color="primary" width="6" />
        <div class="mt-4 text-h6">Cargando catálogo...</div>
        <div class="text-body-2">Por favor espere</div>
      </div>
    </v-overlay>
  </v-card>
</template>

<script>
import { debounce, throttle, memoize } from 'lodash'
import moment from 'moment'

export default {
  name: 'ArticlesCatalogue',

  props: {
    data: {
      type: Object,
      required: true,
      validator: (value) => value && value.business && value.location
    },
    showWarehouse: {
      type: Boolean,
      default: true
    },
    only_mfnr_item: {
      type: Boolean,
      default: false
    },
    removeItemSelected: {
      type: Boolean,
      default: true
    },
    selected_currencies: {
      type: Number,
      default: 1
    },
    itbis: {
      type: Array,
      required: true,
      default: () => []
    },
    type: {
      type: Number,
      default: 1,
      validator: (value) => [1, 2].includes(value)
    }
  },

  data() {
    return {
      // Core data
      paginatedItems: [],
      totalItems: 0,
      categories: [],
      itemsWarehouse: [],

      // Loading states
      initialLoading: true,
      loading: false,
      loadingCategories: false,
      loadingWarehouses: false,
      searchLoading: false,

      // Search and filters
      search: '',
      selectedCategory: null,
      selectedWarehouse: null,
      filters: {
        showOnlyAvailable: false,
        showOnlyWithImages: false
      },

      // Table configuration - OPTIMIZED FOR PERFORMANCE
      options: {
        page: 1,
        itemsPerPage: 20,  // Start with 20 items
        sortBy: [],
        sortDesc: []
      },

      // STRICT page size options for better performance
      itemsPerPageOptions: [
        { text: '10', value: 10 },
        { text: '20', value: 20 },
        { text: '30', value: 30 },
        { text: '50', value: 50 }
      ], // Maximum 50, no more options

      // UI state
      snackbar: false,
      snackbarText: '',
      snackbarColor: 'success',
      snackbarTimeout: 4000,

      imagePreview: {
        show: false,
        item: null
      },

      // Cache
      cachedResults: new Map(),
      warehouseCache: new Map(),

      // Performance
      lastRequestId: 0,
      maxCacheSize: 30, // Reduced cache size

      // Constants
      defaultImage: 'image-not-available.jpg'
    }
  },

  computed: {
    computedHeaders() {
      const isMobile = this.$vuetify?.breakpoint?.mobile || false

      if (isMobile) {
        return [
          { text: 'Artículo', value: 'item_name', sortable: false, width: '60%' },
          { text: 'Cant.', value: 'quantity', width: '15%', align: 'center', sortable: false },
          { text: 'Precio', value: 'price', width: '20%', align: 'end', sortable: false },
          { text: '', value: 'actions', sortable: false, width: '5%', align: 'center' }
        ]
      }

      return [
        { text: 'ID', align: 'start', value: 'item_id', width: '70px', sortable: false },
        { text: 'Img', value: 'image', width: '60px', sortable: false, align: 'center' },
        { text: 'Descripción', value: 'item_name', sortable: false, width: '320px' },
        { text: 'Unidad', value: 'unit_name', width: '80px', align: 'center', sortable: false },
        ...(this.showWarehouse ? [{ text: 'Almacén', value: 'warehouse', width: '150px', align: 'center', sortable: false }] : []),
        { text: 'Cantidad', value: 'quantity', width: '90px', align: 'center', sortable: false },
        { text: 'Precio', value: 'price', width: '100px', align: 'end', sortable: false },
        { text: 'Acciones', value: 'actions', sortable: false, width: '120px', align: 'center' }
      ]
    },

    categoriesWithAll() {
      return [
        { id: null, name: 'Todas las categorías' },
        ...this.categories
      ]
    },

    warehousesWithAll() {
      return [
        { id: null, name: 'Todos los almacenes' },
        ...this.itemsWarehouse
      ]
    },

    footerProps() {
      return {
        'items-per-page-options': this.itemsPerPageOptions,
        'items-per-page-text': 'Por página:',
        'page-text': '{0}-{1} de {2}',
        showFirstLastPage: true,
        showCurrentPage: true
      }
    },

    hasActiveFilters() {
      return !!(
        this.search ||
        this.selectedCategory ||
        this.selectedWarehouse ||
        this.filters.showOnlyAvailable ||
        this.filters.showOnlyWithImages
      )
    },

    searchKey() {
      return [
        this.search,
        this.selectedCategory,
        this.selectedWarehouse,
        this.filters.showOnlyAvailable,
        this.filters.showOnlyWithImages,
        this.options.page,
        this.options.itemsPerPage
      ].join('|')
    }
  },

  watch: {
    options: {
      handler: 'onTableOptionsChange',
      deep: true
    },
    search: {
      handler() {
        this.updateSearch();
      }
    }
  },

  created() {
    this.setupOptimizedMethods()
    this.init()
  },

  beforeDestroy() {
    this.cleanup()
  },

  methods: {
    // Initialization
    async init() {
      if (this.only_mfnr_item) {//SI SE TRATA DEL ARTICULO MERCANCIIA FACTURADA NO RECBIIDA
        this.search = ' - SYSTEM';
      }
      try {
        this.initialLoading = true
        await Promise.all([
          this.getCategories(),
          this.showWarehouse ? this.fetchWarehousesAndInventory() : Promise.resolve()
        ])
        await this.fetchItems()
      } catch (error) {
        this.handleError(error, 'Error al cargar los datos iniciales')
      } finally {
        this.initialLoading = false
      }
    },

    setupOptimizedMethods() {
      this.debouncedSearch = debounce(this.fetchItems, 500) // Increased debounce
      this.throttledTableUpdate = throttle(this.fetchItems, 500) // Increased throttle
      this.memoizedGetWarehouse = memoize(
        this.getWarehouse,
        (item) => `${item.item_id}_${JSON.stringify(item.item_in_warehouses)}`
      )
    },

    // API Calls with enhanced error handling
    async safeApiCall(method, endpoint, data = null) {
      try {
        if (method === 'POST') {
          if (this.api_Post && typeof this.api_Post === 'function') {
            return await this.api_Post(endpoint, data)
          }
        } else if (method === 'GET') {
          if (this.api_Get && typeof this.api_Get === 'function') {
            return await this.api_Get(endpoint)
          }
        }

        // Fallback to fetch
        const config = {
          method,
          headers: { 'Content-Type': 'application/json' }
        }

        if (data && method === 'POST') {
          config.body = JSON.stringify(data)
        }

        return await fetch(`/api/${endpoint}`, config)

      } catch (error) {
        console.error(`API call failed for ${method} ${endpoint}:`, error)
        throw error
      }
    },

    // OPTIMIZED Data Loading - STRICT 50 items maximum
    async fetchItems(retryCount = 0) {
      const requestId = ++this.lastRequestId
      const cacheKey = this.searchKey

      if (this.cachedResults.has(cacheKey)) {
        const cachedData = this.cachedResults.get(cacheKey)
        if (requestId === this.lastRequestId) {
          this.updateTableData(cachedData)
        }
        return
      }

      this.loading = true

      try {
        const searchTerm = this.search || ''

        // CRITICAL: ENFORCE STRICT LIMITS - NEVER MORE THAN 50
        const maxPageSize = Math.min(this.options.itemsPerPage, 50)

        // Double-check: ensure we never send more than 50
        if (maxPageSize > 50) {
          console.warn('Page size exceeds 50, forcing to 50')
          this.options.itemsPerPage = 50
        }
        //TEMPORALMENTE, SI EL USUARIO ES MARIA CANELA FORZA EL ALMACEN SUPERMERCADO POR PETICION DE JUAN MINAYA, PENDIENTE CREAR UN MODULO PARA CONFIGURAR POR USUARIO
        if (this.$store.state.auth.user.user.user_id == 623 && this.data.location == 419) {
          this.selectedWarehouse = 63;
        }
        const requestPayload = {
          date: moment().format('YYYY-MM-DD'),
          business_unit_id: this.data.business,
          location_id: this.data.location,
          is_now: true,
          search: searchTerm,
          page: this.options.page,
          pageSize: maxPageSize, // NEVER more than 50
          category_id: this.selectedCategory === null ? null : this.selectedCategory,
          warehouse_id: this.selectedWarehouse === null ? null : this.selectedWarehouse
        }

        const response = await this.safeApiCall('POST', 'inventory/inventory_value2', requestPayload)

        if (requestId !== this.lastRequestId) {
          return
        }

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`)
        }

        const data = await response.json()

        // SAFETY CHECK: If backend returned more than 50 items, slice it
        if (data.items && data.items.length > 50) {
          console.warn(`Backend returned ${data.items.length} items, limiting to 50`)
          data.items = data.items.slice(0, 50)
        }

        const processedData = this.transformItemsData(data)

        // Apply client-side filters
        const filteredData = this.applyClientFilters(processedData)

        // Cache with size limit
        if (this.cachedResults.size >= this.maxCacheSize) {
          const firstKey = this.cachedResults.keys().next().value
          this.cachedResults.delete(firstKey)
        }
        this.cachedResults.set(cacheKey, filteredData)

        if (requestId === this.lastRequestId) {
          this.updateTableData(filteredData)
        }

      } catch (error) {
        if (requestId === this.lastRequestId) {
          if (retryCount < 2) {
            setTimeout(() => this.fetchItems(retryCount + 1), 1000 * (retryCount + 1))
          } else {
            this.handleError(error, 'Error al cargar los artículos')
          }
        }
      } finally {
        if (requestId === this.lastRequestId) {
          this.loading = false
        }
      }
    },

    async getCategories() {
      this.loadingCategories = true

      try {
        let filters = `where ITEM_CATEGORIES.BUSINESS_UNIT_ID=${this.data.business}`
        if (this.data.location != null) {
          filters += ` AND LOCATION_ID=${this.data.location}`
        }

        const response = await this.safeApiCall('POST', 'inventory/GetCategories', { filters })

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }

        const data = await response.json()
        this.processCategoriesData(data)

      } catch (error) {
        this.handleError(error, 'Error al cargar las categorías')
      } finally {
        this.loadingCategories = false
      }
    },

    async fetchWarehousesAndInventory() {
      this.loadingWarehouses = true

      try {
        const response = await this.safeApiCall('GET', `inventory/warehouseForLocation/${this.data.location}`)

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }

        this.itemsWarehouse = await response.json()

      } catch (error) {
        this.handleError(error, 'Error al cargar los almacenes')
      } finally {
        this.loadingWarehouses = false
      }
    },

    // Data Processing
    transformItemsData(data) {
      return {
        items: data.items.map(item => this.transformItem(item)),
        totalCount: parseInt(data.totalCount, 10) || 0
      }
    },

    transformItem(item) {
      if (!item) return null

      const warehouseOptions = this.memoizedGetWarehouse(item)

      return {
        ...item,
        warehouse_discount: warehouseOptions[0] || null,
        item_image: this.getItemImage(item),
        selecting: false
      }
    },

    applyClientFilters(data) {
      let filteredItems = [...data.items]

      if (this.filters.showOnlyAvailable) {
        filteredItems = filteredItems.filter(item => this.getItemQuantity(item) > 0)
      }

      if (this.filters.showOnlyWithImages) {
        filteredItems = filteredItems.filter(item =>
          item.image_json && item.image_json !== 'null' && item.image_json !== null
        )
      }

      return {
        items: filteredItems,
        totalCount: data.totalCount
      }
    },

    processCategoriesData(data) {
      const formattedCategories = data.map(item => ({
        id: item.id,
        parent: item.parent_category_id,
        name: item.name,
        note: item.note,
        business_unit_id: item.business_unit_id,
        bussines_unit_description: item.bussines_unit_description,
        location_id: item.location_id,
        location_description: item.location_description,
        code: item.code,
        account_type_id: item.account_type_id,
        dgii_category_id: item.dgii_category_id,
        active: item.active
      }))

      const categoryTree = this.nestCategories(formattedCategories)
      this.categories = this.flattenCategoryTree(categoryTree)
    },

    nestCategories(items, id = null, link = 'parent') {
      return items
        .filter(item => item[link] === id)
        .map(item => ({
          ...item,
          children: this.nestCategories(items, item.id)
        }))
    },

    flattenCategoryTree(tree, prefix = '') {
      return tree.reduce((acc, category) => {
        acc.push({
          id: category.id,
          name: prefix + category.name
        })

        if (category.children?.length > 0) {
          acc.push(
            ...this.flattenCategoryTree(category.children, `${prefix}${category.name} > `)
          )
        }

        return acc
      }, [])
    },

    // Event Handlers
    onTableOptionsChange(newVal, oldVal) {
      if (this.shouldRefetchData(newVal, oldVal)) {
        this.throttledTableUpdate()
      }
    },

    onSearchSubmit() {
      this.resetPagination()
      this.fetchItems()
    },

    onCategoryChange() {
      this.resetPagination()
      this.fetchItems()
    },

    onWarehouseChange() {
      this.resetPagination()
      this.fetchItems()
    },

    onAvailabilityFilterChange() {
      this.resetPagination()
      this.fetchItems()
    },

    onImageFilterChange() {
      this.resetPagination()
      this.fetchItems()
    },

    onPageSizeChange() {
      this.resetPagination()
      this.fetchItems()
    },

    updateSearch() {
      this.searchLoading = true
      this.resetPagination()
      // Aseguramos que debouncedSearch siempre retorna una Promise
      Promise.resolve(this.debouncedSearch()).finally(() => {
        this.searchLoading = false
      })
    },

    // Item Operations
    async selectItem(item) {
      if (!this.canSelectItem(item)) return

      item.selecting = true

      try {
        await this.$nextTick()

        this.$emit('selected-item', {
          ...item,
          warehouse: item.warehouse_discount,
          price: this.getPrice(item)
        })

        if (this.removeItemSelected) {
          this.removeFromPaginatedItems(item)
        }

        this.showSnackbar('Artículo agregado correctamente', 'success')

      } catch (error) {
        this.handleError(error, 'Error al agregar el artículo')
      } finally {
        item.selecting = false
      }
    },

    removeFromPaginatedItems(item) {
      const index = this.paginatedItems.findIndex(i => i.item_id === item.item_id)
      if (index !== -1) {
        this.paginatedItems.splice(index, 1)
        this.totalItems = Math.max(0, this.totalItems - 1)
      }
    },

    updateItemWarehouse(item) {
      try {
        this.showSnackbar('Almacén actualizado correctamente', 'success')
      } catch (error) {
        this.handleError(error, 'Error al actualizar el almacén')
      }
    },

    // Utility Methods
    getItemImage(item) {
      if (!item) return this.defaultImage

      if (item.image_json && item.image_json !== 'null' && item.image_json !== null) {
        return this.get_storage ? this.get_storage(item.image_json) : item.image_json
      }
      return this.defaultImage
    },

    get_storage(imagePath) {
      if (!imagePath) return this.defaultImage

      // If it's already a full URL, return as is
      if (typeof imagePath === 'string' && (imagePath.startsWith('http') || imagePath.startsWith('data:'))) {
        return imagePath
      }

      // Default implementation - you should override this in your parent component
      return `/storage/${imagePath}`
    },

    getWarehouse(items) {
      if (!items || !items.item_in_warehouses) return []

      const cacheKey = `${items.item_id}_${JSON.stringify(items.item_in_warehouses)}`

      if (this.warehouseCache.has(cacheKey)) {
        return this.warehouseCache.get(cacheKey)
      }

      const result = items.item_in_warehouses
        .map(ware => {
          const matchingWarehouse = this.itemsWarehouse.find(
            itWare => ware.warehouse_id === itWare.id
          )
          if (matchingWarehouse) {
            return {
              id: ware.warehouse_id,
              name: matchingWarehouse.name,
              quantity: parseFloat(ware.quantity) || 0
            }
          }
          return null
        })
        .filter(Boolean)

      this.warehouseCache.set(cacheKey, result)
      return result
    },

    getWarehouseOptions(item) {
      return this.memoizedGetWarehouse(item)
    },

    getItemQuantity(item) {
      if (!item || !item.warehouse_discount) return 0
      return parseFloat(item.warehouse_discount.quantity) || 0
    },

    getQuantityColor(item) {
      const quantity = this.getItemQuantity(item)
      if (quantity > 50) return 'success'
      if (quantity > 10) return 'info'
      if (quantity > 0) return 'warning'
      return 'error'
    },

    getQuantityIcon(item) {
      const quantity = this.getItemQuantity(item)
      if (quantity > 50) return 'mdi-check-circle'
      if (quantity > 10) return 'mdi-information'
      if (quantity > 0) return 'mdi-alert'
      return 'mdi-close-circle'
    },

    getWarehouseChipColor(warehouse) {
      if (!warehouse) return 'grey'
      const quantity = warehouse.quantity || 0
      if (quantity > 50) return 'success'
      if (quantity > 10) return 'primary'
      if (quantity > 0) return 'orange'
      return 'red'
    },

    getPrice(item) {
      if (!this.selected_currencies || !item.item_currencies?.length) {
        return 0
      }

      const currency = item.item_currencies.find(
        element => element.currency_id === this.selected_currencies
      )
      if (!currency) return 0

      const itbis = parseFloat(
        this.itbis.find(element => element.id === item.tax_type_id)?.value || 0
      ) / 100

      const basePrice = this.type === 1 ?
        parseFloat(currency.cost_price) || 0 :
        parseFloat(currency.sale_price) || 0

      const totalPrice = basePrice * (1 + itbis)

      if (this.type === 1) {
        item.cost_price = totalPrice
      } else {
        item.sale_price = totalPrice
      }

      return totalPrice
    },

    canSelectItem(item) {
      if (this.type === 1 || this.type === 5) return true

      return (
        item.negative_sale ||
        item.item_type_id === 2 ||
        this.getItemQuantity(item) > 0
      )
    },

    getActionButtonColor(item) {
      if (!this.canSelectItem(item)) return 'grey'
      if (item.negative_sale) return 'orange'
      if (item.item_type_id === 2) return 'purple'
      return 'primary'
    },

    getActionIcon(item) {
      if (!this.canSelectItem(item)) return 'mdi-block-helper'
      if (item.negative_sale) return 'mdi-alert'
      if (item.item_type_id === 2) return 'mdi-cog'
      return 'mdi-plus'
    },

    getTooltipText(item) {
      if (item.negative_sale) {
        return 'Este artículo permite ventas negativas'
      } else if (item.item_type_id === 2) {
        return 'Este es un servicio y puede ser vendido'
      } else if (item.warehouse_discount != null && item.warehouse_discount.quantity > 0) {
        return `Disponible: ${this.getItemQuantity(item)} ${item.unit_name || 'unidades'}`
      }
      return 'Este artículo no está disponible para la venta'
    },

    formatCurrency(amount) {
      return new Intl.NumberFormat('es-DO', {
        style: 'currency',
        currency: 'DOP',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(parseFloat(amount) || 0)
    },

    formatQuantity(quantity) {
      const num = parseFloat(quantity) || 0
      return num % 1 === 0 ? num.toString() : num.toFixed(2)
    },

    // UI Methods
    showImagePreview(item) {
      this.imagePreview = {
        show: true,
        item
      }
    },

    clearAllFilters() {
      this.search = ''
      this.selectedCategory = null
      this.selectedWarehouse = null
      this.filters = {
        showOnlyAvailable: false,
        showOnlyWithImages: false
      }
      this.resetPagination()
      this.fetchItems()
    },

    refreshData() {
      this.clearCaches()
      this.fetchItems()
    },

    // Empty state methods
    getEmptyStateIcon() {
      if (this.loading) return 'mdi-loading'
      if (this.hasActiveFilters) return 'mdi-filter-off'
      return 'mdi-package-variant-closed'
    },

    getEmptyStateTitle() {
      if (this.hasActiveFilters) return 'No se encontraron artículos'
      return 'No hay artículos disponibles'
    },

    getEmptyStateMessage() {
      if (this.hasActiveFilters) {
        return 'Intenta ajustar los filtros para encontrar más artículos'
      }
      return 'No hay artículos en el catálogo para esta ubicación'
    },

    // Helper Methods
    shouldRefetchData(newVal, oldVal) {
      return (
        newVal.page !== oldVal.page ||
        newVal.itemsPerPage !== oldVal.itemsPerPage
      )
    },

    resetPagination() {
      this.options.page = 1
      this.clearCaches()
    },

    updateTableData(data) {
      this.paginatedItems = data.items
      this.totalItems = data.totalCount
    },

    clearCaches() {
      this.cachedResults.clear()
      this.warehouseCache.clear()
      if (this.memoizedGetWarehouse?.cache) {
        this.memoizedGetWarehouse.cache.clear()
      }
    },

    cleanup() {
      // Cancel pending operations
      if (this.debouncedSearch?.cancel) this.debouncedSearch.cancel()
      if (this.throttledTableUpdate?.cancel) this.throttledTableUpdate.cancel()

      // Clear caches
      this.clearCaches()
    },

    // Notification Methods
    showSnackbar(text, color = 'success', timeout = 4000) {
      this.snackbarText = text
      this.snackbarColor = color
      this.snackbarTimeout = timeout
      this.snackbar = true
    },

    getNotificationIcon(color) {
      const icons = {
        success: 'mdi-check-circle',
        error: 'mdi-alert-circle',
        warning: 'mdi-alert',
        info: 'mdi-information'
      }
      return icons[color] || 'mdi-information'
    },

    handleError(error, defaultMessage) {
      console.error('ArticlesCatalogue Error:', error)
      const message = error.message || defaultMessage
      this.showSnackbar(message, 'error', 6000)
    }
  }
}
</script>

<style scoped>
/* Optimized styles for better performance and UX */
.v-card {
  background-color: #fafafa;
}

.v-card-title.primary {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%) !important;
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3);
}

.filter-header {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.filter-header .v-input {
  margin-bottom: 0 !important;
}

.filter-header .v-input__control {
  min-height: 40px !important;
}

.filter-header .v-input--checkbox {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.filter-header .v-input--checkbox .v-input__slot {
  margin-bottom: 0 !important;
  align-items: center;
}

.filter-header .v-messages {
  display: none !important;
}

.search-field {
  transition: all 0.3s ease;
}

.search-field:focus-within {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.15);
}

.optimized-table {
  background: white;
  border-radius: 12px;
}

.optimized-table ::v-deep .v-data-table__wrapper {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 12px;
  overflow-x: auto;
}

.optimized-table ::v-deep th {
  background: linear-gradient(135deg, #f1f3f4 0%, #e8eaed 100%) !important;
  font-weight: 600 !important;
  color: #1a1a1a !important;
  border-bottom: 2px solid #e0e0e0 !important;
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 0.5px;
  white-space: nowrap;
  padding: 8px 12px !important;
}

.optimized-table ::v-deep td {
  border-bottom: 1px solid #f0f0f0 !important;
  padding: 8px 12px !important;
  white-space: nowrap;
}

.optimized-table ::v-deep tbody tr {
  transition: all 0.2s ease;
}

.optimized-table ::v-deep tbody tr:hover {
  background: linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 100%) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.image-container {
  position: relative;
}

.image-avatar {
  border: 2px solid #e0e0e0;
  transition: all 0.3s ease;
  cursor: pointer;
}

.image-avatar:hover {
  border-color: #1976d2;
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.3);
}

.item-description {
  max-width: 300px;
}

.price-container {
  min-width: 100px;
}

.action-btn {
  transition: all 0.2s ease;
  text-transform: none !important;
  font-weight: 500;
  border-radius: 6px;
}

.action-btn:hover {
  transform: scale(1.02);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.action-btn.v-btn--disabled {
  opacity: 0.6 !important;
}

.mobile-item-container {
  width: 100%;
}

.empty-state {
  min-height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.v-chip {
  font-weight: 600;
  font-size: 0.75rem;
}

.v-btn {
  text-transform: none;
  font-weight: 500;
  border-radius: 8px;
}

/* Checkbox alignment fixes */
.v-input--selection-controls {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.v-input--selection-controls .v-input__slot {
  margin-bottom: 0 !important;
}

.v-input--selection-controls .v-input__slot>.v-label {
  font-size: 0.875rem;
}

/* Responsive Design */
@media (max-width: 1264px) {
  .filter-header .v-col {
    margin-bottom: 8px;
  }
}

@media (max-width: 960px) {
  .optimized-table ::v-deep .v-data-table__wrapper {
    font-size: 0.875rem;
  }

  .action-btn {
    min-width: 70px !important;
    padding: 0 8px !important;
    font-size: 0.75rem;
  }

  .price-container {
    min-width: 80px;
  }

  .item-description {
    max-width: 200px;
  }

  .v-data-table ::v-deep th,
  .v-data-table ::v-deep td {
    padding: 4px 6px !important;
    font-size: 0.8rem;
  }

  .filter-header .v-input--checkbox .v-label {
    font-size: 0.75rem !important;
  }
}

@media (max-width: 600px) {
  .optimized-table ::v-deep .v-data-table__wrapper {
    font-size: 0.75rem;
  }

  .image-avatar {
    width: 32px !important;
    height: 32px !important;
  }

  .v-data-table ::v-deep th,
  .v-data-table ::v-deep td {
    padding: 2px 4px !important;
    font-size: 0.75rem;
  }

  .mobile-item-container .text-subtitle-2 {
    font-size: 0.8rem !important;
  }

  .mobile-item-container .text-caption {
    font-size: 0.7rem !important;
  }

  .action-btn {
    min-width: 60px !important;
    font-size: 0.7rem;
  }
}

/* Table scroll optimization */
.v-data-table__wrapper {
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;
}

.v-data-table__wrapper::-webkit-scrollbar {
  height: 6px;
  width: 6px;
}

.v-data-table__wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.v-data-table__wrapper::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Accessibility improvements */
.v-btn:focus {
  outline: 2px solid #1976d2;
  outline-offset: 2px;
}

/* Prevent text overflow */
.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Fixed width containers to prevent overflow */
.optimized-table {
  width: 100%;
  overflow: hidden;
}

.optimized-table ::v-deep table {
  table-layout: fixed;
  width: 100%;
}

/* Progress bar enhancement */
.v-data-table ::v-deep .v-data-table__progress {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
}

.mobile-item-container .text-subtitle-2 {
  font-size: 0.8rem !important;
}

.mobile-item-container .text-caption {
  font-size: 0.7rem !important;
}


/* Compact filter design */
.filter-header .v-input {
  margin-bottom: 0 !important;
}

.filter-header .v-input__control {
  min-height: 40px !important;
}

/* Table scroll optimization */
.v-data-table__wrapper {
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;
}

.v-data-table__wrapper::-webkit-scrollbar {
  height: 6px;
  width: 6px;
}

.v-data-table__wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.v-data-table__wrapper::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Accessibility improvements */
.v-btn:focus {
  outline: 2px solid #1976d2;
  outline-offset: 2px;
}

/* Prevent text overflow */
.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Fixed width containers to prevent overflow */
.optimized-table {
  width: 100%;
  overflow: hidden;
}

.optimized-table ::v-deep table {
  table-layout: fixed;
  width: 100%;
}

/* Progress bar enhancement */
.v-data-table ::v-deep .v-data-table__progress {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
}
</style>
